import {
    Block,
    CHILD_REQUIRED,
    NODE_DATA_INVALID,
    type NodeType,
    Schema,
    type SchemaNormalizeViolationFn,
    Text,
} from '@gitbook/slate';

import { BLOCK_DIVIDER, BLOCK_PARAGRAPH } from '../types';
import { validateTextAlignment } from '../utils';

/*
 * Core schema to ensure the metadata and all nodes are valid.
 */
export const schema = Schema.create({
    document: {
        nodes: [{ objects: ['block'], min: 1 }],
        normalize: (change, violation, context) => {
            switch (violation) {
                case CHILD_REQUIRED:
                    change.insertNodeByKey(
                        // @ts-expect-error
                        context.node.key,
                        0,
                        Block.create({
                            type: BLOCK_PARAGRAPH,
                            nodes: [Text.create('')],
                        }),
                        { normalize: false }
                    );
                    break;
                default:
                    break;
            }
        },
    },
    blocks: {
        [BLOCK_PARAGRAPH]: {
            nodes: [{ objects: ['inline', 'text'] }],
            data: {
                // Legacy property before introduction of block BLOCK_DIVIDER
                // We used it when parsing Markdown/HTML with <hr /> tag
                __horizontal_rule__: (value) => typeof value === 'undefined',
                align: validateTextAlignment,
            },
            // Cast: the normalizer is authored for the narrow `Block` node it is
            // registered against, but the `normalize` slot is typed for the wide
            // `NodeType`. The schema only ever calls it with the matching block.
            normalize: Schema.createNormalize<Block>({
                [NODE_DATA_INVALID]: (change, context) => {
                    if (context.key === '__horizontal_rule__') {
                        if (context.node.isEmpty) {
                            // If empty, we replace by a divider
                            change.replaceNodeByKey(
                                context.node.key,
                                Block.create({ type: BLOCK_DIVIDER, isVoid: true })
                            );
                        } else {
                            // If not empty, we consider it a normal paragraph
                            change.removeDataPathByKey(context.node.key, [context.key]);
                        }
                    }
                },
            }) as SchemaNormalizeViolationFn<NodeType>,
        },
    },
});
